// extracted by mini-css-extract-plugin
export default {"title":"DetailOneInvoice_title__7hBme","box-fields":"DetailOneInvoice_box-fields__ierf7","fields":"DetailOneInvoice_fields__lv+du"};